import React from "react";
import { ShieldCheck, CircleAlert, CircleDashed, Send } from "lucide-react";
import { EntryStatus } from "../../types";
import { classNames } from "../../lib/format";

export function StatusBadge({ status }: { status: EntryStatus }) {
  const map: Record<EntryStatus, { label: string; className: string; icon: React.ReactNode }> = {
    "Da processare": { label: "Da processare", className: "bg-gray-100 text-gray-800 ring-1 ring-gray-200", icon: <CircleDashed className="h-3.5 w-3.5" /> },
    "Registra":       { label: "Registra",       className: "bg-blue-100 text-blue-800 ring-1 ring-blue-200",  icon: <Send className="h-3.5 w-3.5" /> },
    "Confermato":    { label: "Confermato",    className: "bg-green-100 text-green-800 ring-1 ring-green-200", icon: <ShieldCheck className="h-3.5 w-3.5" /> },
    "Ignora":        { label: "Ignora",        className: "bg-amber-100 text-amber-800 ring-1 ring-amber-200", icon: <CircleAlert className="h-3.5 w-3.5" /> },
  };
  const s = map[status];
  return (
    <span className={classNames("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium", s.className)}>
      {s.icon}
      {s.label}
    </span>
  );
}
